<template>
  <div></div>
</template>

<script>
const DEFAULT_LOCALE = process.env.VUE_APP_I18N_LOCALE;

export default {
  name: 'Logout',

  created() {
    /**
     * TODO:
     * 1. Destroy local token and redirect to 'login' route
     * 2. Send request to API to remove token
     */

    if (this.$store.getters['auth/hasToken']) {
      this.$store
        .dispatch('auth/destroyToken')
        .then(() => {
          this.$i18n.locale = DEFAULT_LOCALE;
          this.$vuetify.lang.current = DEFAULT_LOCALE;
          this.$store.commit('localization/lang', DEFAULT_LOCALE);
          this.$store.commit('auth/destroyedToken');
          this.$router.push({ name: 'login' });
        })
        .catch(() => {
          this.$store.commit('auth/destroyedToken');
          this.$router.push({ name: 'login' });
        });
    }
  }
};
</script>
